import SchoolAvatar from './SchoolAvatar';

export default function PickupStudentsCard({
  students = [],
  title = 'Students Heading to Pickup',
  subtitle,
  hint = 'Tap student to confirm pickup',
  actionLabel = 'View Full Queue',
  actionDisabled = false,
  emptyMessage = 'No students heading to pickup yet',
  emptyClassName = '',
  hideActionWhenEmpty = false,
  onActionClick,
  onConfirmPickup,
  className = '',
}) {
  const resolvedSubtitle = subtitle || `${students.length} heading to pickup`;
  const classes = ['sd-card', 'sd-pickup-students', className].filter(Boolean).join(' ');
  const showEmptyState = students.length === 0;
  const emptyClasses = ['sd-card-empty', emptyClassName].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <h3>{title}</h3>
      <p className="sd-card-sub">{resolvedSubtitle}</p>
      {hint ? <p className="sd-card-hint">{hint}</p> : null}
      {showEmptyState ? (
        <div className={emptyClasses}>{emptyMessage}</div>
      ) : (
        <div className="sd-pickup-list">
          {students.map((student, index) => {
            const clickable = Boolean(onConfirmPickup) && !student.confirmed;
            const RowTag = clickable ? 'button' : 'div';
            const rowProps = clickable
              ? { type: 'button', onClick: () => onConfirmPickup(student) }
              : {};
            return (
              <RowTag
                key={student.id || `${student.name}-${student.grade}-${index}`}
                className={`sd-pickup-item ${clickable ? 'is-clickable' : ''}`}
                {...rowProps}
              >
                <SchoolAvatar record={student} seed={student.id ?? index} className="sd-pickup-avatar" />
                <div className="sd-pickup-info sd-pickup-copy">
                  <div className="sd-pickup-name">{student.name}</div>
                  <div className="sd-pickup-grade">{student.grade}</div>
                </div>
                <div className={`sd-pickup-check ${student.confirmed ? 'checked' : ''}`}></div>
              </RowTag>
            );
          })}
        </div>
      )}
      {!(showEmptyState && hideActionWhenEmpty) ? (
        <button
          type="button"
          className="sd-card-btn sd-pickup-btn"
          onClick={onActionClick}
          disabled={actionDisabled}
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
